import React from "react";
import "../components/componentstyle/gelleryData.css";
import SharedEventGallery from "./SharedEventGallery";

function GelleryData() {
  return <SharedEventGallery className="gellery" title="Gellery"/>;
}

export default GelleryData;
